// removed by extract-text-webpack-plugin
module.exports = {"container":"_2RiZB3Sqd4k2T8QfDlfipy","banner_content":"_2oZpbjrjkN5IqTpOh1cLxK","banner":"_3rWKhIne9BKL5iXMhT-jJZ","banner_background":"_1Hbi0u-dfOkxDwsMeZDyBw","news_content":"_1gSNd_u0Dp9nBN8uehbbIq"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/News/index.less
// module id = 516
// module chunks = 0